import React from 'react';

import './TitleLightBold.css';

const TitleLightBold = (props) => {
    const classesBold = ["custom-font-weight-bolder"];
    const classesLight = ["custom-font-weight-lighter","text-center"];
    if (props.boldDisplayBlock) {
        classesBold.push("d-block");
    }
    if(!props.initSection){
        classesBold.push("custom-text-black");
        classesLight.push("custom-text-black");
    }
    let returnComponent = null;
    switch (props.titleType) {
        case "h1":
            returnComponent = <h1 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h1>;
            break;
        case "h2":
            returnComponent = <h2 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h2>;
            break;
        case "h3":
            returnComponent = <h3 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h3>;
            break;
        case "h4":
            returnComponent = <h4 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h4>;
            break;
        case "h5":
            returnComponent = <h5 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h5>;
            break;
        case "h6":
            returnComponent = <h6 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h6>;
            break;
        default:
            returnComponent = <h1 className={classesLight.join(' ')}>{props.textLight}<strong className={classesBold.join(' ')}>{props.textBold}</strong></h1>;
            break;
    }
    return (
        returnComponent
    );
};

export default TitleLightBold;